module.exports = __webpack_public_path__ + "static/media/commentCount.d7b5424d.svg";